module.exports = __webpack_public_path__ + "static/media/yiChuan-class-1.b5c73edc.jpg";